import publicConfig from "../public-config.js";

import { request as httpRequest } from "./http-library.js";

const ssoHost = publicConfig.external_address;

export const Profile = {
  read: function readProfile(path, accessToken, callback) {
    const requestParams = {
      host: ssoHost,
      path,
      method: "GET",
    };
    if (accessToken) {
      requestParams.headers = {
        Authorization: "Bearer " + accessToken,
      };
    }
    httpRequest(
      requestParams,
      function (response) {
        callback(response);
      },
      null,
    );
  },

  // this is legacy code that is used for the old endpoint, as soon as we are fully switched to FA and BE updates, we should remove this
  update: function updateProfile(path, accessToken, profileBody, callback) {
    const requestParams = {
      host: ssoHost,
      path: "/v1/profiles/" + path,
      method: "PUT",
      headers: {
        Authorization: "Bearer " + accessToken,
      },
    };
    httpRequest(
      requestParams,
      function (response) {
        callback(response);
      },
      profileBody,
    );
  },
  // as soon as we are fully switched to FA we should switch over to use this API and not Profile.update
  updateNew: function updateProfileNew(accessToken, profileBody, callback) {
    const requestParams = {
      host: ssoHost,
      path: "/v2/profiles/update-details",
      method: "POST",
      headers: {
        Authorization: "Bearer " + accessToken,
      },
    };
    httpRequest(
      requestParams,
      function (response) {
        callback(response);
      },
      profileBody,
    );
  },

  fetchPhoneVerifyCodeOld: function fetchPhoneVerifyCodeOld(
    accessToken,
    callback,
  ) {
    const requestParams = {
      host: ssoHost,
      path: "/v1/profiles/me/phone/verify",
      method: "GET",
    };
    if (accessToken) {
      requestParams.headers = {
        Authorization: "Bearer " + accessToken,
      };
    }
    httpRequest(
      requestParams,
      function (response) {
        callback(response);
      },
      null,
    );
  },

  fetchPhoneVerifyCode: function fetchPhoneVerifyCode(accessToken, callback) {
    const requestParams = {
      host: ssoHost,
      path: "/v2/profiles/phone-verification/start",
      method: "POST",
    };
    if (accessToken) {
      requestParams.headers = {
        Authorization: "Bearer " + accessToken,
      };
    }
    httpRequest(
      requestParams,
      function (response) {
        callback(response);
      },
      null,
    );
  },

  submitPhoneVerifyCode: function fetchPhoneVerifyCode(
    accessToken,
    payload,
    callback,
  ) {
    const requestParams = {
      host: ssoHost,
      path: "/v2/profiles/phone-verification/complete",
      method: "POST",
    };
    if (accessToken) {
      requestParams.headers = {
        Authorization: "Bearer " + accessToken,
      };
    }
    httpRequest(
      requestParams,
      function (response) {
        callback(response);
      },
      payload,
    );
  },

  submitPhoneVerifyCodeOld: function fetchPhoneVerifyCodeOld(
    accessToken,
    payload,
    callback,
  ) {
    const requestParams = {
      host: ssoHost,
      path: "/v1/profiles/me/phone/verify",
      method: "PUT",
    };
    if (accessToken) {
      requestParams.headers = {
        Authorization: "Bearer " + accessToken,
      };
    }
    httpRequest(
      requestParams,
      function (response) {
        callback(response);
      },
      payload,
    );
  },

  readCredits: function readProfileCredits(ssoId, accessToken, callback) {
    const requestParams = {
      host: ssoHost,
      path: `/v1/profiles/${ssoId}/credit`,
      method: "GET",
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    };

    httpRequest(
      requestParams,
      function (response) {
        callback(response);
      },
      null,
    );
  },

  sendBankVerificationEmail: function sendBankVerificationEmail(
    accessToken,
    callback,
  ) {
    const requestParams = {
      host: ssoHost,
      path: "/v1/profiles/me/authorizations/bank-update",
      method: "POST",
      headers: {
        Authorization: "Bearer " + accessToken,
      },
    };
    httpRequest(requestParams, function (response) {
      callback(response);
    });
  },

  getIdvStatus: function readProfile(
    ssoId,
    accessToken,
    triggerType,
    callback,
  ) {
    const requestParams = {
      host: ssoHost,
      path: `/v2/profiles/${ssoId}/idv_status?trigger_type=${triggerType}`,
      method: "GET",
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    };
    httpRequest(
      requestParams,
      function (response) {
        callback(response);
      },
      null,
    );
  },
  updateExperience: function updateExperience(experienceId, callback) {
    const requestParams = {
      host: ssoHost,
      path: `/v1/profiles/me/experience/${experienceId}`,
      method: "PUT",
      headers: {
        Authorization: `Bearer ${window.PSSessions.Cookies("PSAccess")}`,
      },
    };

    httpRequest(
      requestParams,
      function (response) {
        callback(response);
      },
      { complete_exp: true },
    );
  },
};
